import React from "react";

const EMOJI_FONT =
  '"Apple Color Emoji", "Segoe UI Emoji", "Noto Color Emoji", "Twemoji Mozilla", "Segoe UI Symbol", "Arial Unicode MS", sans-serif';

interface SectorIconProps {
  emoji: string;
  size?: number;
  style?: React.CSSProperties;
  className?: string;
}

/**
 * Renders a sector/industry emoji in a consistent wrapper.
 * Currently uses native Unicode emoji (they render on all platforms).
 * Can be swapped to SVG later without changing call sites.
 */
export default function SectorIcon({ emoji, size = 14, style, className }: SectorIconProps) {
  if (!emoji) return null;

  return (
    <span
      className={className}
      style={{
        fontSize: size,
        lineHeight: 1,
        fontFamily: EMOJI_FONT,
        flexShrink: 0,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        ...style,
      }}
    >
      {emoji}
    </span>
  );
}
